import { render, staticRenderFns } from "./socialMediaIcons.vue?vue&type=template&id=4b1f1608"
import script from "./socialMediaIcons.vue?vue&type=script&lang=js"
export * from "./socialMediaIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports